import React from "react";
import Footer from "../Footer/Footer.tsx"; // Adjust the import path as needed
import EditorHeader from "../Header/EditorHeader.tsx";

// The Layout component will accept children as a prop, ensuring that it's typed properly
const EditorLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div>
      <EditorHeader />
        <div style={{paddingTop: '20px'}}>
          <main>{children}</main>
        </div>
      <Footer />
    </div>
  );
};

export default EditorLayout;
